export const computed = {
    searchServicesList() {
        if (!this.searchServices) {
            if (this.mailsSelected) {
                return [...this.computedPopularMailServices];
            }
            return [...this.computedPopularServices]
        }

        return this.searchServiceCompFunction;
    },

    computedPopularServices() {
        const BREAKPOINTS = {
            SM: {max: 767, countItem: 6, countRow: 4},
            MD: {max: 859, countItem: 8, countRow: 3},
            LG: {max: 1023, countItem: 12, countRow: 3},
            XL: {max: Infinity, countItem: 7, countRow: 3}
        };

        let rowCount = 3;
        let itemsPerRow;
        const currentWidth = this.windowWidth;

        if (currentWidth <= BREAKPOINTS.SM.max) {
            itemsPerRow = BREAKPOINTS.SM.countItem;
            rowCount = BREAKPOINTS.SM.countRow;
        } else if (currentWidth <= BREAKPOINTS.MD.max) {
            itemsPerRow = BREAKPOINTS.MD.countItem;
        } else if (currentWidth <= BREAKPOINTS.LG.max) {
            itemsPerRow = BREAKPOINTS.LG.countItem;
        } else {
            itemsPerRow = BREAKPOINTS.XL.countItem;
        }

        return this.popularServices.slice(0, itemsPerRow * rowCount);
    },
    computedPopularMailServices() {
        const BREAKPOINTS = {
            SM: {max: 639, countItem: 6, countRow: 5},
            MD: {max: 859, countItem: 8, countRow: 5},
            LG: {max: 1023, countItem: 12, countRow: 4},
            XL: {max: Infinity, countItem: 7, countRow: 5}
        };

        let rowCount = 5;
        let itemsPerRow;
        const currentWidth = this.windowWidth;

        if (currentWidth <= BREAKPOINTS.SM.max) {
            itemsPerRow = BREAKPOINTS.SM.countItem;
        } else if (currentWidth <= BREAKPOINTS.MD.max) {
            itemsPerRow = BREAKPOINTS.MD.countItem;
        } else if (currentWidth <= BREAKPOINTS.LG.max) {
            itemsPerRow = BREAKPOINTS.LG.countItem;
            rowCount = BREAKPOINTS.LG.countRow;
        } else {
            itemsPerRow = BREAKPOINTS.XL.countItem;
        }

        return this.popularMailServices.slice(0, itemsPerRow * rowCount);
    },

    searchServicesListWrapper() {
        if (!this.searchServices) {
            if (this.mailsSelected) {
                return [...this.mailsServices];
            }
            return [...this.services]
        }
        return this.searchServiceCompFunction;

    },
    searchServiceCompFunction() {
        const searchServices = (this.searchServices || '').trim().toLowerCase();
        return this[this.typeServices].filter(
            service => {
                return service.alternative_params
                    && service.alternative_params.name_search
                    && service.alternative_params.name_search.toLowerCase().includes(searchServices)
                    || service.title && service.title.toLowerCase().includes(searchServices);
            }
        );
    },
    placeholderServices() {
        if (this.isFocusSearchService || !this.selectedService) {
            this.selected = false;
            return this.getLocalization('Find service');
        }
        this.selected = true;
        return this.getLocalization('Selected') + ' ' + this.getLocalization(this.selectedService.title).toUpperCase();
    },

    searchCountriesList() {
        if (!this.searchCountries) {
            return [...this.serviceCountries]
        }

        const searchCountries = (this.searchCountries || '').trim().toLowerCase();
        return this.serviceCountries.filter(service => service.alternative_title_locale && service.alternative_title_locale.toLowerCase().includes(searchCountries));
    },
    searchMailDomainsList() {
        if (!this.searchDomains) {
            return [...this.mailDomains]
        }
        let searchDomains = (this.searchDomains || '').trim().toLowerCase();
        return this.mailDomains.filter(mail => mail.domain.front_name && mail.domain.front_name.toLowerCase().includes(searchDomains));
    },
    isChineseLanguage() {
        return document.documentElement.lang === 'zh' || document.documentElement.lang === 'cn';
    },
    isRussianLanguage() {
        return document.documentElement.lang === 'ru';
    }
}